import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { IServerErrorResponse } from '../../../types';
import { flattenServerErrorResponse } from '../../../helpers/errors.helper';

interface ChangePersonalAddressProps {
  street: string;
  apt: string;
  city: string;
  state: string;
  zip: string;
  customerId: string;
  businessFlow: boolean;
}
export interface ChangePersonalAddressReturn {
  string: string;
}
export const useChangePersonalAddreess = (
  onSuccess: (response: ChangePersonalAddressReturn) => void,
  onError: (error: any) => void,
  businessFlow: boolean,
) =>
  useMutation(
    'changePersonalAddress',
    async ({ apt, city, state, street, zip, customerId }: ChangePersonalAddressProps) => {
      const apiLink = businessFlow
        ? `${BASE_URL}/api/v1/user/${customerId}/businessAddress`
        : `${BASE_URL}/api/v1/user/${customerId}/address`;
      const { data } = await httpService.post(apiLink, {
        city,
        state,
        line1: street,
        line2: apt,
        postalCode: zip,
        country: 'US',
      });
      return data;
    },
    {
      onSuccess: (data) => onSuccess(data),
      onError: (error: IServerErrorResponse) => {
        onError(flattenServerErrorResponse(error));
      },
    },
  );
